/**
 * @desc test
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(params: API.fulfilment.test.test.Params, options?: any) {
  return updateResponse(
    http(URL + `/test/test`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
